// @ts-ignore
import Vuetify from 'vuetify/lib/framework'
import * as directives from 'vuetify/lib/directives'
// @ts-ignore
import { ru } from 'vuetify/lib/locale'
import Vue from 'src/configs/vue'

Vue.use(Vuetify, {
  directives,
})

const opts = {
  lang: {
    current: 'ru',
    locales: { ru },
  },
  theme: {
    disable: true,
  },
  icons: {
    iconfont: 'ui-icon',
    values: {
      next: 'ui-icon-arrow-right ui-icon-fz-smaller',
      prev: 'ui-icon-arrow-left ui-icon-fz-smaller',
      radioOn: 'ui-icon-radio-on',
      radioOff: 'ui-icon-radio-off',
      checkboxOn: 'ui-icon-checkbox-on',
      checkboxOff: 'ui-icon-checkbox-off',
      closeNotCircle: 'ui-icon-close-not-a-circle',
      emailIcon: 'ui-icon-at-sign',
      arrowDown: 'ui-icon-arrow-down',
      clear: 'ui-icon-close-not-a-circle',
    },
  },
}

// Фабрика для SSR: отдельный инстанс на рендер, чтобы не удерживать ссылки между запросами.
export function createVuetify() {
  return new Vuetify(opts)
}

// Default-инстанс используется в клиентском рендере.
export default createVuetify()
